// extracted by mini-css-extract-plugin
module.exports = {"root":"Homepage_root__hhve3","h1":"Homepage_h1__NyVSk","h3":"Homepage_h3__1ywYg","video":"Homepage_video__3HTL0","content":"Homepage_content__Lhh00"};